import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./App.css";
import App from "./App";
import Axios from "axios";
import store from "./store";
import { Provider } from "react-redux";
import { Helmet } from "react-helmet";
import {
  createMuiTheme,
  ThemeProvider,
  StylesProvider,
  jssPreset,
} from "@material-ui/core/styles";
import rtl from "jss-rtl";
import { create } from "jss";
//
const jss = create({ plugins: [...jssPreset().plugins, rtl()] });
const theme = createMuiTheme({
  typography: {
    fontFamily: ["iransansdn"].join(","),
  },
  direction: "rtl",
  palette: {
    secondary: {
      main: "#000",
    },
    primary: {
      main: "#27AE60",
    },
    link: {
      main: "#2D9CDB",
    },
  },
});

Axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;
Axios.defaults.headers.post["Content-Type"] = "application/json";
// Axios.defaults.validateStatus = (status) => {
//   console.log(status);
//   if (status === 401) console.log("logout");
//   return
// };
ReactDOM.render(
  <React.Fragment>
    <Helmet>
      <link rel="manifest" href="/manifest.json" />
      <link
        rel="icon"
        type="image/png"
        sizes="512x512"
        href="/images/icon/android-chrome-512x512.png"
      />
      <link
        rel="apple-touch-icon"
        sizes="512x512"
        href="/images/icon/android-chrome-512x512.png"
      />
      <link
        rel="apple-touch-startup-image"
        href="/images/icon/apple-touch-icon.png"
      />
      <link
        href="/images/icon/android-chrome-512x512.png"
        sizes="2048x2732"
        rel="apple-touch-startup-image"
      />
      <link
        href="/images/icon/android-chrome-512x512.png"
        sizes="1668x2224"
        rel="apple-touch-startup-image"
      />
      <link
        href="/images/icon/android-chrome-512x512.png"
        sizes="1536x2048"
        rel="apple-touch-startup-image"
      />
      <link
        href="/images/icon/android-chrome-512x512.png"
        sizes="1125x2436"
        rel="apple-touch-startup-image"
      />
      <link
        href="/images/icon/android-chrome-512x512.png"
        sizes="1242x2208"
        rel="apple-touch-startup-image"
      />
      <link
        href="/images/icon/android-chrome-512x512.png"
        sizes="750x1334"
        rel="apple-touch-startup-image"
      />
      <link
        href="/images/icon/android-chrome-512x512.png"
        sizes="640x1136"
        rel="apple-touch-startup-image"
      />
    </Helmet>
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <StylesProvider jss={jss}>
          <App />
        </StylesProvider>
      </Provider>
    </ThemeProvider>
  </React.Fragment>,
  document.getElementById("root")
);
